import { Image } from "@src/components/Image";
import { getAwsAssets } from "../../utils";
import RightArrowIcon from "../../components/AccentIcons/RightArrowIcon";
import { useEffect, useState } from "react";
import LockedModal from "../../components/Tabs/Content/components/ContentList/LockedModal";
import { buyNowDoubtBuddyModalAction } from "../store/actions";
import { useDispatch } from "react-redux";


function DoubtBudyButton({meta}) {
    const [isTimeOut,setIsTimeOut] = useState(false);
    const [isLokedModalOpen,setIsLokedModalOpen] = useState(false);
    const dispatch = useDispatch();
    const doubtUrl = meta?.bundleData?.bundles?.filter((items) => items?.courseType === "DOUBTBUDDY")[0]?.doubtBuddyUrl || "";

    useEffect(() => {
        const timer = setTimeout(()=> {
            setIsTimeOut(true);
        }, 5000);
        return () => {
            clearTimeout(timer)
        }
    })
    const handleDoubtBuddyButton = () => {
        if(meta?.isPurchased === 1 && doubtUrl) {
            window.location.href = doubtUrl
        } else {
            dispatch(buyNowDoubtBuddyModalAction(true))

        }
    }
    function handleModal() {
        setIsLokedModalOpen(false)
    }
    return (
        <>
        <div className="doubtBudyCOntainer" style={isTimeOut ? {display:"flex"} : {display:"block"}} >
        <div className="doubtBudy" onClick={() => handleDoubtBuddyButton()} style={{width:isTimeOut  ? "62px" : "100%"}}>
            <div style={{height:"36px"}}>
                <img src={getAwsAssets("doubtMate8aug2024.svg", "Overview")} alt="" width={36}  />
            </div>
            <div className="doubtBudy__rightDiv" style={isTimeOut ? {display:"none"} : {display:"flex"}}>
                <div>
                    <p className="doubtBudy__rightDiv__title">Click Photo, Get Answer</p>
                    <p className="doubtBudy__rightDiv__subTitle">Resolve your doubts with DoubtMate</p>
                </div>
                <RightArrowIcon color="26292c" />
            </div>
        </div>
        </div>
        </>
    )
}

export default DoubtBudyButton;